<template>
  <div
    class="relative row-span-1 flex cursor-pointer items-center rounded-xl p-2 shadow-main transition-all hover:-translate-y-2 hover:shadow-elevated lg:p-4 gap-2 lg:gap-4"
    @click="addToCart"
  >
    <div class="h-20 w-auto overflow-hidden sm:h-36 md:h-40 lg:h-26 lg:max-lg:mt-0 xl:h-20"
    >
      <MyImage
        :src="dish.thumbnail"
        :alt="dish.name"
      />
    </div>
      <div class="flex gap-2 flex-col lg:text-lg text-[10px]" style="min-width: 50%;">
          {{ dish.name }}
          <span class="font-medium"> {{ dish.price }}&nbsp;&#8381; </span>
      </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue'
import type { Dish, Tag } from '~/interfaces/dishes'
import { useAddToBasket } from '~/composables/api/basket'

const props = defineProps<{
    dish: Dish
}>()
const { dish } = toRefs(props)

const { mutate } = useAddToBasket()
const addToCart = () => {
    mutate({
        dish_id: dish.value.id,
        dish_name: dish.value.name,
        quantity: 1
    })
}

</script>
